export const staticUrls = {
  daycareDefault1: 'https://assets.urbansitter.com/static/img/facilities/daycareDefault-1.webp',
  daycareDefault2: 'https://assets.urbansitter.com/static/img/facilities/daycareDefault-2.webp',
  daycareDefault3: 'https://assets.urbansitter.com/static/img/facilities/daycareDefault-3.webp',
  daycareDefault4: 'https://assets.urbansitter.com/static/img/facilities/daycareDefault-4.webp',
  daycareDefault5: 'https://assets.urbansitter.com/static/img/facilities/daycareDefault-5.webp',
  daycareDefault6: 'https://assets.urbansitter.com/static/img/facilities/daycareDefault-6.webp',
};
